import { LongGameError } from './error.js';
export function assert(condition, errorMessage) {
    if (!condition) {
        throw new LongGameError(LongGameError.Code.BadRequest, errorMessage);
    }
}
//# sourceMappingURL=assert.js.map